module.exports = __webpack_public_path__ + "static/img/wei.c4755c0f.png";